import { create } from 'zustand';

export type FlyToTarget = {
  longitude: number;
  latitude: number;
  zoom: number;
};

type UiState = {
  selectedPersonId: string | null;
  panelOpen: boolean;
  flyToTarget: FlyToTarget | null;
  filterPanelOpen: boolean;
  selectPerson: (id: string | null) => void;
  closePanel: () => void;
  setFlyTo: (target: FlyToTarget | null) => void;
  setFilterPanelOpen: (open: boolean) => void;
  toggleFilterPanel: () => void;
};

export const useUiStore = create<UiState>((set) => ({
  selectedPersonId: null,
  panelOpen: false,
  flyToTarget: null,
  filterPanelOpen: false,
  selectPerson: (id) =>
    set({ selectedPersonId: id, panelOpen: id !== null }),
  closePanel: () => set({ panelOpen: false }),
  setFlyTo: (target) => set({ flyToTarget: target }),
  setFilterPanelOpen: (open) => set({ filterPanelOpen: open }),
  toggleFilterPanel: () =>
    set((s) => ({ filterPanelOpen: !s.filterPanelOpen })),
}));
